import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.scss";
import { Context } from "../Store";
import { motion } from "framer-motion";
const UpboxLinks = (props) => {
  let { dir } = useContext(Context);
  const { googlePlay } = props;
  return (
    <>
      {dir === "rtl" ? (
        <motion.li
          whileHover={{
            x: -4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <a href={googlePlay} target="_blank" className={`${styles.link}`}>
            حمل التطبيق
          </a>
        </motion.li>
      ) : (
        <motion.li
          whileHover={{
            x: 4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <a href={googlePlay} target="_blank" className={`${styles.link}`}>
            Application Download
          </a>
        </motion.li>
      )}
      {dir === "rtl" ? (
        <motion.li
          whileHover={{
            x: -4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="privacy-Policy" className={`${styles.link}`}>
            سياسة الخصوصية
          </Link>
        </motion.li>
      ) : (
        <motion.li
          whileHover={{
            x: 4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="privacy-Policy" className={`${styles.link}`}>
            Privacy Policy
          </Link>
        </motion.li>
      )}
      {dir === "rtl" ? (
        <motion.li
          whileHover={{
            x: -4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="terms&conditions" className={`${styles.link}`}>
            الشروط والأحكام
          </Link>
        </motion.li>
      ) : (
        <motion.li
          whileHover={{
            x: 4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="terms&conditions" className={`${styles.link}`}>
            Terms & Conditions
          </Link>
        </motion.li>
      )}
      {dir === "rtl" ? (
        <motion.li
          whileHover={{
            x: -4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="payment&refund-policy" className={`${styles.link}`}>
            سياسة الدفع والاسترداد
          </Link>
        </motion.li>
      ) : (
        <motion.li
          whileHover={{
            x: 4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="payment&refund-policy" className={`${styles.link}`}>
            Payment and Refund Policy
          </Link>
        </motion.li>
      )}
      {dir === "rtl" ? (
        <motion.li
          whileHover={{
            x: -4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="contact-us" className={`${styles.link}`}>
            المساعدة
          </Link>
        </motion.li>
      ) : (
        <motion.li
          whileHover={{
            x: 4,
            transition: {
              type: "spring",
              mass: 1,
              stiffness: 1601,
              damping: 60,
            },
          }}
        >
          <Link to="contact-us" className={`${styles.link}`}>
            Help
          </Link>
        </motion.li>
      )}
    </>
  );
};

export default UpboxLinks;
